import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
})
export class NotFoundPageComponent {

}
